import React, { useState } from "react";
import { motion } from "framer-motion";

interface IProps {
  setCanEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setIsDrawMode: React.Dispatch<React.SetStateAction<boolean>>;
  setShapeType: React.Dispatch<React.SetStateAction<string>>;
}

const ToggleEditButton = ({
  setCanEdit,
  setIsDrawMode,
  setShapeType,
}: IProps) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const handleEditMode = () => {
    setCanEdit(true);
    setIsEditMode(true);
  };

  const handleViewMode = () => {
    setCanEdit(false);
    setIsDrawMode(false);
    setIsEditMode(false);
    setShapeType(""); // Reset shape type when exiting edit mode
  };

  return (
    <div
      className={`relative cursor-pointer ${
        isEditMode ? "h-[61px] mt-[21px]" : "h-[84px]"
      }`}
      onClick={isEditMode ? handleViewMode : handleEditMode}
    >
      <motion.div
        className={`bg-[#2C2C2C] py-2 px-1 border border-[#565555] rounded-[5px] w-[32px] ${
          isEditMode ? "h-[32px]" : "h-[34px]"
        } relative ${isEditMode ? "top-0" : "top-[26px]"}`}
        title={isEditMode ? "Disable Edit" : "Enable Edit"}
        initial={{ y: 0 }}
        animate={{ y: isEditMode ? -10 : 10 }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <img
          src={
            isEditMode ? "/images/sidebar/edit.png" : "/images/sidebar/eye.png"
          }
          alt=""
          className={`relative ${isEditMode ? "left-[3px]" : "left-[2px]"}`}
        />
      </motion.div>
      <motion.div
        className="relative top-[-32px] -z-10 left-[2px] w-[28px] h-[58px] flex items-center justify-center rounded-[7px]"
        initial={{ y: 0 }}
        animate={{ y: isEditMode ? -10 : 10 }}
        transition={{ type: "spring", stiffness: 200 }}
        style={{
          backgroundColor: isEditMode
            ? "rgb(37 99 235 / var(--tw-bg-opacity, 1))"
            : "#565555",
        }}
      ></motion.div>
    </div>
  );
};

export default ToggleEditButton;
